<template>
    <BasePanel 
        headline="lang_ACCOUNT_COMPANIES_CAPTION_INVOICES_PANEL"
        :alvqa="alvqa"
    >            
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="itemsPerPage"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >

                <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.type`]="{ item }">
                    <BaseTooltip>
                    <template v-slot:text>{{ $t(getLangOfType(item.type)) }}</template>
                        <template v-slot:content>
                            <span :alvqa="alvqa + '-list-row-' + item.type + '-text-type'">
                                {{ $t(getLangOfType(item.type, "abbr")) }}
                            </span>
                        </template>
                    </BaseTooltip>
                </template>

                <template v-slot:[`item.date`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-date'">
                        {{ $d(new Date(item.date), 'alvDateFormat', $i18n.locale) }}
                    </div>
                </template>

                <template v-slot:[`item.period`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-period-of-service'">
                        {{ $d(new Date(getPeriodOfService(item)), 'alvMonthYearFormat') }}
                    </div>
                </template>

                <template v-slot:[`item.forYear`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-for-year'">
                        {{ item.forYear }}
                    </div>
                </template>

                <template v-slot:[`item.invoiceNumber`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-invoice-number'">
                        {{ item.invoiceNumber }}
                    </div>
                </template>

                <template v-slot:[`item.amountGross`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-amount-gross'">
                        {{ $n(item.amountGross, 'number') }}
                    </div>
                </template>

                <template v-slot:[`item.downloadLink`]="{ item }">
                    <BaseIcon 
                        v-if="item.downloadLink !== null"
                        @click.stop="downloadFile(item.downloadLink)"
                        icon="cloud_download"
                        tooltipText="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                        :alvqa="alvqa + '-invoices-' + item.id + '-icon-download'"
                    />
                </template>

                <!-- <template v-slot:[`item.downloadLink`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-download-link'">
                        <a :href="item.downloadLink" target="_blank">
                            Download
                        </a>
                    </div>
                </template> -->

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseInlineEditingDataTable from "@/components/_base/BaseInlineEditingDataTable"
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'
import {    DropdownErpInvoicesType,
            } from '@/assets/dropdowns/alvDropdowns.js'
import api from '@/api_alv'

export default {
    name: "InvoicesEditPanel",  
    components: { 
        BasePanel,
        BaseIcon,
        BaseInlineEditingDataTable,
        BaseButton,
        BaseTooltip,
        DropdownErpInvoicesType,
    },
    data() {
        return {
            alvqa: 'account-companies-edit-form-panel-invoices'
        }
    },
    computed: {
        items() { 
            return this.$store.getters.getAccountInvoices 
        },
		/** Returns an Array with header-objects with props.
         *  @return {[{text: String, align: string, value: string}]} props of the header */
        headers() {
            return [
                {   text: this.$t('lang_ACCOUNT_COMPANIES_INVOICES_CAPTION_TYPE'), 
                    alvqa: this.alvqa + "header-type",
                    value: "type",
                    align: 'left', 
                    sortable: false,
                    width: "50px",
                },
                {   text: this.$t('lang_ACCOUNT_COMPANIES_INVOICES_CAPTION_DATE'), 
                    alvqa: this.alvqa + "header-date",
                    value: 'date',
                    align: 'left', 
                    sortable: false,
                    width: "90px",
            },
                {   text: this.$t('lang_ERP_INVOICES_CAPTION_PERIOD_OF_SERVICE'), 
                    alvqa: this.alvqa + "header-period-of-service",
                    align: "right", 
                    width: "180px",
                    sortable: false,
                    value: "period", 
                },
                {   text: this.$t('lang_ACCOUNT_COMPANIES_INVOICES_CAPTION_INVOICE_NUMBER'), 
                    alvqa: this.alvqa + "header-invoiceNumber",
                    align: 'left', 
                    width: "160px",
                    sortable: false,
                    value: "invoiceNumber", 
                },
                {   text: this.$t('lang_ACCOUNT_COMPANIES_INVOICES_CAPTION_AMOUNT_GROSS'), 
                    alvqa: this.alvqa + "header-amountGross",
                    align: 'right', 
                    width: "140px",
                    sortable: false,
                    value: "amountGross", 
                },
                {   text: this.$t('lang_ACCOUNT_COMPANIES_INVOICES_CAPTION_DOWNLOAD_LINK'), 
                    alvqa: this.alvqa + "header-downloadLink",
                    align: "left", 
                    width: "150px",
                    sortable: false,
                    value: "downloadLink", 
                },
                {
					text: '', 
					value: 'ghost',
					sortable: false,
					width: "50%",
					class: 'text-no-wrap'
				},
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        getLangOfType(selection, type = "text") {
            return DropdownErpInvoicesType.find(obj => {
                return obj.value == selection
            })[type]
        },
        getPeriodOfService(item) {
            return item.forYear + "-" + item.forMonth 
        },
        downloadFile(path) {
            api.getFileFromALV(path)
        }
    },
    created() {
        this.$store.dispatch('fetchAccountInvoices')
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>